(() => {
  function initFaq(root) {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = 'true';

    const search = root.querySelector('[data-faq-search]');
    const categories = [...root.querySelectorAll('[data-faq-category]')];
    const items = [...root.querySelectorAll('[data-faq-item]')];
    const heading = root.querySelector('[data-faq-heading]');
    const count = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('[data-faq-empty]');
    let category = 'All Questions';

    function update() {
      const query = search.value.trim().toLocaleLowerCase();
      let visible = 0;

      items.forEach((item) => {
        const matchesCategory = category === 'All Questions' || item.dataset.faqType === category;
        const matchesSearch = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !(matchesCategory && matchesSearch);
        if (!item.hidden) visible += 1;
      });

      heading.textContent = category;
      count.textContent = `${visible} ${visible === 1 ? 'question' : 'questions'}`;
      empty.hidden = visible !== 0;
    }

    categories.forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.faqCategory;
        categories.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', String(active));
        });
        update();
      });
    });

    search.addEventListener('input', update);
    update();
  }

  function initAll(container = document) {
    container.querySelectorAll('[data-nwan-faq]').forEach(initFaq);
  }

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
